import(/* webpackMode: "eager" */ "/app/packages/tokyu-web/app/(pages)/[locale]/template.tsx");
